import { H5LIVE_SETTINGS } from './H5liveView';

// The MOQ tab is served by the same backend controllers as H5Live (the player reports the identical
// metric set and only names the used playback API) under mirrored routes, so the zoom tables are
// identical apart from the API namespace.
export const MOQ_SETTINGS = Object.keys(H5LIVE_SETTINGS).reduce((settings, metric) => {
   const config = H5LIVE_SETTINGS[metric];
   settings[metric] = { ...config, path: config.path.replace('h5live/', 'moq/') };
   return settings;
}, {});
